import * as React from "react";
import {Attributes, Component} from "react";
import {Collapse} from "react-bootstrap";
import {TabOrderWidget} from "ui/experience/widgets/toolbox/TabOrder/TabOrderDndTypes";
import TabOrderComponent from "ui/experience/widgets/toolbox/TabOrder/TabOrderComponent";

interface ExperienceSettingsProps extends Attributes {
    spectatorMode: string;
    widgetSelected: boolean;
    widgets?: TabOrderWidget[];
    removedWidgets?: TabOrderWidget[];
    selectedId?: string;
    orderEnabled: boolean;
    emailModeEnabled: boolean;
    onItemRemove: (id: string, columnId: string, oldIndex?: number, newIndex?: number) => void;
    onDragEnd: (columnId?: string, oldIndex?: number, newIndex?: number) => void;
    onDragStart: (uuid: string) => void;
    onDragCancel: () => void;
}

interface ExperienceSettingsState {
    collapsed: boolean;
    previousWidgetSelected: boolean;
    shouldForceUpdate: boolean;
}

// noinspection JSUnusedGlobalSymbols
class WidgetTabOrderContainer extends Component<ExperienceSettingsProps, ExperienceSettingsState> {
    static getDerivedStateFromProps(props: ExperienceSettingsProps, state: ExperienceSettingsState) {
        if(props.widgetSelected !== state.previousWidgetSelected) {
            return {collapsed: props.widgetSelected, previousWidgetSelected: props.widgetSelected};
        }
        return null;
    }

    constructor(props: ExperienceSettingsProps) {
        super(props);

        this.state = {
            collapsed: props.widgetSelected,
            previousWidgetSelected: props.widgetSelected,
            shouldForceUpdate: false,
        };
    }

    toggleCollapse = () => {
        this.setState({collapsed: !this.state.collapsed});
    }

    haveWidgetsChanged = (widgets: TabOrderWidget[], previousWidgets: TabOrderWidget[]) => {
        return widgets.length !== previousWidgets.length ||
        widgets.find((widget, index) => {
            // we're assuming the order remains the same. Maybe we should always force an update.
            const previousWidget = previousWidgets[index];
            return widget !== previousWidget;
        });
    }

    componentDidUpdate =
        (prevProps: Readonly<ExperienceSettingsProps>): void => {
            const shouldForceUpdate = this.haveWidgetsChanged(this.props.widgets, prevProps.widgets) ||
                this.haveWidgetsChanged(this.props.removedWidgets, prevProps.removedWidgets);

            if(!!shouldForceUpdate && !this.state.shouldForceUpdate) {
                this.setState({shouldForceUpdate: true});
            } else if (prevProps.emailModeEnabled !== this.props.emailModeEnabled) {
                this.setState({shouldForceUpdate: true});
            } else if(this.state.shouldForceUpdate) {
                this.setState({shouldForceUpdate: false});
            }
        }

    render () {
        const {
            spectatorMode,
            widgets,
            removedWidgets,
            emailModeEnabled,
            selectedId,
            onDragEnd,
            onDragStart,
            onDragCancel,
            orderEnabled,
            onItemRemove,
        } = this.props;
        const {collapsed, shouldForceUpdate} = this.state;
        const inputsDisabled = !!spectatorMode;

        const tabOrderEnabled = orderEnabled && !inputsDisabled;

        const collapsedClass = collapsed ? "collapsible collapsed" : "collapsible";

        return (
            <div className="experience-settings">
                <legend
                    className={`${collapsedClass} ${emailModeEnabled ? "disabled" : ""}`}
                    onClick={this.toggleCollapse}
                >
                    Widget Tab Order
                </legend>
                <Collapse in={!collapsed && !emailModeEnabled}>
                    <div>
                        {!shouldForceUpdate && widgets  &&
                            <TabOrderComponent
                                widgets={widgets}
                                removedWidgets={removedWidgets}
                                orderEnabled={tabOrderEnabled}
                                selectedId={selectedId}
                                onDragEnd={onDragEnd}
                                onDragStart={onDragStart}
                                onDragCancel={onDragCancel}
                                onItemRemove={onItemRemove}
                            />
                        }
                    </div>
                </Collapse>
            </div>
        );
    }
}

// noinspection JSUnusedGlobalSymbols
export {
    WidgetTabOrderContainer as default,
    WidgetTabOrderContainer,
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/WidgetTabOrderContainer.tsx